import { render, staticRenderFns } from "./videoBackground.vue?vue&type=template&id=484204b1&scoped=true"
import script from "./videoBackground.vue?vue&type=script&lang=js"
export * from "./videoBackground.vue?vue&type=script&lang=js"
import style0 from "./videoBackground.vue?vue&type=style&index=0&id=484204b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484204b1",
  null
  
)

export default component.exports